<app-overview-reporting-card [standardReports]="standardReports"></app-overview-reporting-card>
